import Vue from 'vue';
import WidgetAudioNuxt from '@xd-rocket/widgets/src/audio/nuxt.vue';
import WidgetCarouselNuxt from '@xd-rocket/widgets/src/carousel/nuxt.vue';
import WidgetDefaultNuxt from '@xd-rocket/widgets/src/default/nuxt.vue';
import WidgetFrameNuxt from '@xd-rocket/widgets/src/frame/nuxt.vue';
import WidgetImageNuxt from '@xd-rocket/widgets/src/image/nuxt.vue';
import WidgetLinkButtonNuxt from '@xd-rocket/widgets/src/link-button/nuxt.vue';
// import WidgetQrCodeNuxt from '@xd-rocket/widgets/src/qr-code/nuxt.vue';
import WidgetRichTextNuxt from '@xd-rocket/widgets/src/rich-text/nuxt.vue';
import WidgetTextNuxt from '@xd-rocket/widgets/src/text/nuxt.vue';
import WidgetVideoNuxt from '@xd-rocket/widgets/src/video/nuxt.vue';
import WidgetVideoCanvasNuxt from '@xd-rocket/widgets/src/videoCanvas/nuxt.vue';
import WidgetRemoteNuxt from '@xd-rocket/widgets/src/remote/nuxt.vue';
// import WidgetCdkeyNuxt from '@xd-rocket/widgets/src/cdkey/nuxt.vue';
import WidgetInputNuxt from '@xd-rocket/widgets/src/input/nuxt.vue';
import WidgetSvgNuxt from '@xd-rocket/widgets/src/svg/nuxt.vue';
import WidgetProgressNuxt from '@xd-rocket/widgets/src/progress/nuxt.vue';

const components = {
  WidgetAudioNuxt, //: () => import('@xd-rocket/widgets/src/audio/nuxt.vue'),
  WidgetCarouselNuxt, //: () => import('@xd-rocket/widgets/src/carousel/nuxt.vue'),
  WidgetDefaultNuxt, //: () => import('@xd-rocket/widgets/src/default/nuxt.vue'),
  WidgetFrameNuxt, //: () => import('@xd-rocket/widgets/src/frame/nuxt.vue'),
  WidgetImageNuxt, //: () => import('@xd-rocket/widgets/src/image/nuxt.vue'),
  WidgetLinkButtonNuxt, //: () => import('@xd-rocket/widgets/src/link-button/nuxt.vue'),
  WidgetQrCodeNuxt: () => import('@xd-rocket/widgets/src/qr-code/nuxt.vue'),
  WidgetRichTextNuxt, //: () => import('@xd-rocket/widgets/src/rich-text/nuxt.vue'),
  WidgetTextNuxt,
  WidgetVideoNuxt, //: () => import('@xd-rocket/widgets/src/video/nuxt.vue'),
  WidgetVideoCanvasNuxt,
  WidgetRemoteNuxt, //: () => import('@xd-rocket/widgets/src/remote/nuxt.vue'),
  WidgetCdkeyNuxt: () => import('@xd-rocket/widgets/src/cdkey/nuxt.vue'),
  WidgetInputNuxt,
  WidgetSvgNuxt,
  WidgetProgressNuxt,
};
const Element = {
  install(Vue) {
    for (let i in components) {
      let component = components[i];
      Vue.component(component.name, component);
    }
    // components.forEach((component) => {
    //   Vue.component(component.name, component);
    // });
  },
};
// console.log('Vue.use(Plugin)!!!!!!!!!!!');
Vue.use(Element);
